import { render } from "./NxgTrackWidget.vue?vue&type=template&id=44c21688"
import script from "./NxgTrackWidget.vue?vue&type=script&lang=js"
export * from "./NxgTrackWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__